import { render, staticRenderFns } from "./lawyerOnline.vue?vue&type=template&id=33c4fbd2&"
import script from "./lawyerOnline.vue?vue&type=script&lang=js&"
export * from "./lawyerOnline.vue?vue&type=script&lang=js&"
import style0 from "./lawyerOnline.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports